exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DownloadButton__button___jkvrS {\n  background-color: #f94144;\n  color: white; }\n\n.DownloadButton__button___jkvrS {\n  float: right;\n  padding: 0px 10px;\n  height: 30px;\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"button": "DownloadButton__button___jkvrS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/containers/FinancePage/FinanceList/DownloadButton/DownloadButton.scss
// module id = 5112
// module chunks = 6